<template>
    <v-progress-circular
      v-if = "uploadstarted"
      density="compact"
      indeterminate
      color="primary"
    ></v-progress-circular>

    <v-alert
    v-if = "uploadsuccess"
    density="compact"
    type="warning"
    title="Success"
    text="Bild was uploaded!"
    ></v-alert>

    <v-alert
    v-if = "uploaderror"
    density="compact"
    type="warning"
    title="Upload fehlgeschlagen"
    :text="uploadErrorMessage"
    ></v-alert>

    <v-card class="mx-auto">
      <v-card-title>Bild hochladen</v-card-title>
      <v-card-text>
        <v-file-input
          v-model="file"
          :disabled="uploadstarted"
          label="Bilddatei auswaehlen"
          show-size
          outlined
          dense
          hint="Android Chrome: ueber Dateien/Original-JPG waehlen, nicht ueber Schnellvorschau. So bleiben EXIF-GPS-Daten eher erhalten."
          persistent-hint
        ></v-file-input>
        <v-alert :type="uploadGeoInfoType" variant="tonal" density="compact" class="mt-3">
          {{ uploadGeoInfo }}
        </v-alert>
        <div v-if="selectedFile" class="mt-3">
          <p><strong>Dateiname:</strong> {{ selectedFile.name }}</p>
          <p><strong>Dateigröße:</strong> {{ (selectedFile.size / 1024).toFixed(2) }} KB</p>
          <v-img
            :src="imagePreview"
            alt="Vorschau"
            max-height="200"
            contain
            class="my-3"
          ></v-img>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          variant="outlined"
          :loading="manualGeoLoading"
          :disabled="uploadstarted || geoLoading"
          @click="useCurrentPositionForUpload"
        >
          Aktuelle Position verwenden
        </v-btn>
        <v-btn
          :disabled="!selectedFile || uploadstarted || manualGeoLoading || geoLoading"
          :loading="uploadstarted"
          color="primary"
          @click="uploadFile"
        >
          Hochladen
        </v-btn>
      </v-card-actions>
    </v-card>




   <v-form v-model="valid">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="assembly_Benennung"
            label="assembly_Benennung"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="Bild_Beschreibung"
            label="Bild_Beschreibung"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="email"
            label="E-mail"
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </v-form>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import imageUploadGeo from '@/mixins/imageUploadGeo';
import { formatImageUploadError } from '@/utils/imageUploadError';

export default {
  name: 'ImageUploadScreen',
  mixins: [imageUploadGeo],
  data() {
    return {
      uploadedimage:'',
      uploadsuccess: false,
      uploaderror: false,
      uploadErrorMessage: '',
      uploadstarted: false,
      assembly_Benennung: 'new Asi von vueti3',
      Bild_Beschreibung: ' ', //muss etwas enthalten sonst funktioniert der Aufruf nicht
      file: null,
      imagePreview: null,
      exifCoordinates: null,
      manualUploadCoordinates: null,
      manualGeoLoading: false,
      geoLoading: false,
      uploadGeoInfo: 'Bitte Bild auswählen. GPS-Daten aus dem Bild werden bevorzugt verwendet.',
      uploadGeoInfoType: 'info',

    };
  },
  watch: {
    async selectedFile(newFile) {
      this.exifCoordinates = null;
      this.manualUploadCoordinates = null;
      this.uploadsuccess = false;
      this.uploaderror = false;
      this.geoLoading = Boolean(newFile);
      this.imagePreview = null;
      this.uploadGeoInfo = newFile ? 'GPS-Daten im Bild werden geprüft …' : 'Bitte Bild auswählen.';
      this.uploadGeoInfoType = 'info';
      if (newFile) {
        this.generatePreview(newFile);
        const coordinates = await this.getExifCoordinates(newFile);
        if (this.selectedFile !== newFile) return;
        this.exifCoordinates = coordinates;
        this.geoLoading = false;
        this.updateUploadGeoInfo();
      }
    },
  },
  created: function() {
    console.log('Bin in ImageUpload')
    //return this.$store.dispatch('getNotes');
  },
  computed: {
    selectedFile() {
      return Array.isArray(this.file) ? this.file[0] || null : this.file;
    },
    ...mapGetters({ assemblies: 'stateAssemblies'}),
/*    filterDesserts() {
      return this.desserts.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    }*/
  },
  methods: {
  ...mapActions(['createAssembly','createBildmitfiles']),
    updateUploadGeoInfo() {
      const coordinates = this.exifCoordinates || this.manualUploadCoordinates;
      if (coordinates) {
        const source = this.exifCoordinates ? 'GPS aus dem Bild' : 'Aktuelle Position';
        this.uploadGeoInfo = `${source} wird verwendet: ${coordinates.latitude.toFixed(6)}, ${coordinates.longitude.toFixed(6)}.`;
        this.uploadGeoInfoType = 'success';
      } else {
        this.uploadGeoInfo = 'Keine GPS-Daten im Bild gefunden. Du kannst die aktuelle Position verwenden oder ohne Standort fortfahren.';
        this.uploadGeoInfoType = 'info';
      }
    },
    async useCurrentPositionForUpload() {
      if (this.manualGeoLoading || this.uploadstarted || this.geoLoading) return;
      this.manualGeoLoading = true;
      const file = this.selectedFile;
      try {
        const coordinates = await this.getCurrentPositionOnce();
        if (this.selectedFile !== file) return;
        if (!this.hasCoordinates(coordinates.latitude, coordinates.longitude)) {
          this.uploadGeoInfo = 'Der Browser hat keine gültigen Standortkoordinaten geliefert. Bitte erneut versuchen.';
          this.uploadGeoInfoType = 'warning';
          return;
        }
        this.manualUploadCoordinates = coordinates;
        this.updateUploadGeoInfo();
      } catch (_) {
        if (this.selectedFile !== file) return;
        this.uploadGeoInfo = 'Aktuelle Position konnte nicht ermittelt werden. Bitte die Standortfreigabe im Browser prüfen.';
        this.uploadGeoInfoType = 'warning';
      } finally {
        this.manualGeoLoading = false;
      }
    },
//    async submit() {
//      console.log('ImageUploadScreen')
//    },
//    onFileChange(e) {
//      console.log('Bin in onFileChange')
//      var files = e.target.files || e.dataTransfer.files;
//      if (!files.length)
//        return;
//      this.uploadedimage = files[0]
//      this.createImage(files[0]);
//    },
//    createImage(file) {
//      var image = new Image();
//      var reader = new FileReader();
//      var vm = this;
//        this.uploadstarted = true
//          console.log('Bin in createImage')
//          var ctx = this.$refs.myCanvas.getContext('2d')
//
//      reader.onload = (e) => {
//        vm.image = e.target.result;
//        var dataURL = e.target.result
//
//          image.onload = function() {
//        //Skalierung ermitteln
//        var MAX_WIDTH = 1000;
//        var MAX_HEIGHT = 600;
//        var width = image.width;
//        var height = image.height;
//
//        if (width > height) {
//          if (width > MAX_WIDTH) {
//          height *= MAX_WIDTH / width;
//          width = MAX_WIDTH;
//          }
//        } else {
//          if (height > MAX_HEIGHT) {
//          width *= MAX_HEIGHT / height;
//          height = MAX_HEIGHT;
//          }
//        }
//            ctx.width = image.width;
//            ctx.height = image.height;
//            ctx.drawImage(image, 0, 0,width,height);
//            vm.createAssemblyV2()
//          };
//
//          image.src = dataURL;
//
//      };
//      reader.readAsDataURL(file);
//    },

    generatePreview(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.selectedFile !== file) return;
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadFile() {
      if (!this.selectedFile || this.uploadstarted || this.manualGeoLoading || this.geoLoading) return;

      this.uploadstarted = true
      this.uploadsuccess = false
      this.uploaderror = false
      this.createAssemblyV2()
//      const formData = new FormData();
//      formData.append("file", this.file);
//
//      // Hier ein Beispiel-API-Aufruf
//      fetch("https://example.com/api/upload", {
//        method: "POST",
//        body: formData,
//      })
//        .then((response) => response.json())
//        .then((data) => {
//          alert("Erfolgreich hochgeladen!",data);
//        })
//        .catch((error) => {
//          console.error("Fehler beim Hochladen:", error);
//        });
    },
    async createAssemblyV2() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      var todayOhnetime = yyyy + '-' + mm + '-' + dd;

      var neuerAssembly = {
        "assembly_Benennung": this.assembly_Benennung,
        "assembly_DatumErstellung": todayOhnetime,
        "assembly_DatumAenderung": today,
        "assembly_Bewertung": 0,
        "Kategorie_idKategorie": 55,
        "assembly_Preis": 0,
        "assembly_Beschreibung": "",
        "assembly_Rezension": "",
        "user_iduser": 1
      }

      let operation = 'Assembly anlegen / laden'
      try {
        const assembly = await this.createAssembly(neuerAssembly)
        if (!assembly?.idassembly) {
          this.uploaderror = true
          this.uploadErrorMessage = 'Die Serverantwort enthält keine Assembly-ID. Das Bild wurde nicht hochgeladen.'
          this.uploadstarted = false
          return
        }
        operation = 'Bild hochladen'

        var formData = new FormData();
        formData.append("file", this.selectedFile)
        formData.append('assembly_id', assembly.idassembly);
        formData.append('Bilder_Benennung', this.Bild_Beschreibung)
        const coordinates = this.exifCoordinates || this.manualUploadCoordinates;
        if (coordinates && this.hasCoordinates(coordinates.latitude, coordinates.longitude)) {
          formData.append('bilder_geo_longi_X', coordinates.longitude);
          formData.append('bilder_geo_lati_Y', coordinates.latitude);
        }
        // Ohne Koordinaten kann die API weiterhin EXIF aus der Originaldatei auslesen.

        const response = await this.$store.dispatch('createBildmitfiles', formData)
        console.log("Got some data, now lets show something in this component", response)
        this.uploadsuccess = true
        this.uploadstarted = false
      } catch (error) {
        console.error(error)
        this.uploaderror = true
        this.uploadErrorMessage = formatImageUploadError(error, operation)
        this.uploadstarted = false
      }

    },


  },
};
</script>

